class ImageAnimation extends HTMLElement {
    constructor() {
      super()
      this.init();
    }
  
    async init() {
      window.addEventListener('scroll', () => {
        const position = window.scrollY;
        if(this.getBoundingClientRect().top < 200) {
          gsap.to("[js-animate-image]", {xPercent: (position - 500) / 10, duration: 1, yoyo: true})
        }
      })
    }

  }
  
customElements.define('image-animation', ImageAnimation)
